import { useMutation } from '@apollo/client/react';
import { toast } from 'sonner';

import { SoftwareEscrowEnableReportsDocument } from 'src/graphql/actions/reports/softwareEscrowEnableReports.mutation';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { getApiError, ClientError } from 'src/utils/errors';
import { Button } from '@/components/ui/button';
import { GetVerifiedLevelDialog } from '@/widgets/VerificationAddOns';
import { softwareEscrowAddonsDictionary, AddOnTypeEnum } from 'src/shared/entities/verification-addons';

type Props = {
  triggerNode?: React.ReactNode;
};

const GetAddOnAction = ({ triggerNode }: Props) => {
  const {
    softwareEscrow: { id: softwareEscrowId, policy },
  } = useSoftwareEscrow();
  const [enableReports, { loading }] = useMutation(SoftwareEscrowEnableReportsDocument);

  const onEnableReports = async () => {
    try {
      const { data } = await enableReports({
        variables: {
          softwareEscrowId,
        },
      });

      if (data?.softwareEscrowEnableReports?.errors?.length) {
        throw new ClientError(data?.softwareEscrowEnableReports?.errors[0]);
      } else
        toast.success('Add-on added successfully!', {
          description: 'Reports are coming your way and your escrow will be verified in no time.',
        });
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  if (!policy.enableReports) return null;

  return (
    <GetVerifiedLevelDialog
      price={softwareEscrowAddonsDictionary[AddOnTypeEnum.VERIFIED].price}
      description="Automated review of supported materials and their updates. Reports are visible to all members with asset visibility."
      triggerNode={
        triggerNode || (
          <Button size="sm" className="w-full">
            Get Add-on
          </Button>
        )
      }
      onGetAddOn={onEnableReports}
      isLoading={loading}
    />
  );
};

export default GetAddOnAction;
